import { QueryParams } from '@domain/types';
import { Http } from '@services/http';

export const PATIENTS_PATH = '/patients';

// CRUD Patient

export async function getPatients(searchParams: QueryParams) {
  return await Http.getInstance().get({ path: PATIENTS_PATH, searchParams });
}
